import { render, staticRenderFns } from "./BaseDashboardTable.vue?vue&type=template&id=14fb9a8d"
import script from "./BaseDashboardTable.vue?vue&type=script&lang=js"
export * from "./BaseDashboardTable.vue?vue&type=script&lang=js"
import style0 from "./BaseDashboardTable.vue?vue&type=style&index=0&id=14fb9a8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports